/**
 * @module
 */

import {portal} from './core/portal.js';
import {publisher} from './core/publisher.js';
import {inject} from './core/service/ng.js';
import {navigator} from './core/navigator.js';

const app = {
  navigator,
  publisher,
  portal,
  get LANG() {
    return document.body.lang;
  },
  get user() {
    return inject('user');
  },

  /**
   * @depreacted
   */
  PORTAL: portal.abbr,

  /**
   * @deprecated
   */
  get FSK() {
    return this.user.fsk;
  },
};

export {app};
